import { getBoundaries } from '../../../helpers/state-selector'
import stateHelper from '../../../helpers/state-abbreviation'
import moverHelper from '../../../helpers/mover-helper'
import mapHelper from '../../../helpers/map-helper'
import * as _ from 'lodash'
import store from '../../../store/index'

export default {
  name: 'get-state',
  data () {
    return {
      polygons: {},
      tag_line : null,
      showHelper: false,
      exclusion : false,
      loading: true
    }
  },
  beforeRouteEnter: function (to, from, next) {
    let selected_areas = store.getters.selectedAreas;
    let user = store.getters.user;
    if (user && user.completed_process) {
        next('/thankyou');
    }
    else if (!selected_areas.length) {
        next('/pickup/get-state');
    }
    next(true);
  },
  created () {
  },
  mounted () {
    this.$store.dispatch("removeSelectedAreas")
    this.checkMap()
    this.getExcludedStates();
    this.showInitialHelperMsg();
  },
  destroyed () {
    this.$store.dispatch('removePolygons');
    this.$store.dispatch("removeSelectedAreas")
  },
  methods: {
    showInitialHelperMsg: function() {
      let showText = localStorage.getItem('showGetExclusionHelpText');
      if(!showText){
        this.showHelper = true;
        this.tag_line = 'Select entire states you do not deliver to. Area code delivery exclusions are not accepted. AK, HI, PR are automatically added as exclusion states',
        localStorage.setItem('showGetExclusionHelpText', true)
        setTimeout(() => {
          this.showHelper = false;
        }, 5000)
      }
    },
    goBack() {
      this.$router.push({name : "get-state"});
    },
    closepopup() {
      document.getElementById('popup').style.display = 'none';
    },
    getExcludedStates() {
      console.log('this.$store.getters.excludedAreas' , this.$store.getters.excludedAreas)
      let user = this.$store.getters.user;
      if(!_.isEmpty(this.$store.getters.excludedAreas) || !user.completed_process){
          this.loading = false;
          return;
      }

      let api_url = process.env.API_URL + '/user/'+this.$store.getters.clientId;
      let params = {
          'token': this.$store.getters.accessToken,
          'w': 'exclusions'
      };

      this.$http.get(api_url, {params: params}).then(response => {
        response = response.data || response;

        if (response.completed_process) {
            this.$router.push('/thankyou');
            return;
        }
        this.$store.commit("setUser", response);
        
        let exclusions = response.exclusion_states;
        moverHelper.setExcludedAreas(exclusions);
        this.makePolygons();
        this.loading = false;
      }).catch(error => {
        localStorage.setItem('access_token', '');
        localStorage.setItem('client_id', '');
        localStorage.setItem('user', '');
        this.$store.commit('setAccessToken', null);
        this.$store.commit('setClientId', null);
        this.$store.commit('setUser', null);
        this.$router.push('/pickup/client-login');
      })
    },
    checkMap() {
      mapHelper._isGoogleLoaded({infobox:true}).then(val =>{
          this.makePolygons()
      })
    },
    initSelectedStates(){
        mapHelper.initSelectedStates()
    },
    polygonHoverListners(stateData){
      google.maps.event.addListener(this.$store.getters.polygons[stateData], 'mouseover', () => {
        if (this.$store.getters.excludedAreas.findIndex(estate => { return estate.state === stateData }) < 0) {
          this.$store.getters.polygons[stateData].setOptions({ strokeOpacity: 0.4, fillOpacity: 0.4 })
        }
      })
      google.maps.event.addListener(this.$store.getters.polygons[stateData], 'mouseout', () => {
        if (this.$store.getters.excludedAreas.findIndex(estate => { return estate.state === stateData }) < 0) {
          this.$store.getters.polygons[stateData].setOptions({ strokeOpacity: 0, fillOpacity: 0 })
        }
      })
    },
    polygonClickListner(stateData){
      google.maps.event.addListener(this.$store.getters.polygons[stateData], 'click', () => {
        if (!this.$store.getters.polygons[stateData]) {
            return
        }
        if (this.$store.getters.excludedAreas.findIndex(estate => { return estate.state === stateData }) > -1) {
            this.unselectPolygon(this.$store.getters.polygons[stateData], stateData)
            return
        }
        this.$store.commit('setSelectedState', stateData)
        this.selectPolygon( this.$store.getters.polygons[stateData], stateData )
      })
    },
    makePolygons () {
      this.$store.dispatch('removeAreaCodes')
      this.$store.dispatch('removePolygons');
      this.$store.dispatch("removeSelectedAreas")

      this.$store.getters.map.setZoom(5)
      let boundaries = getBoundaries()
      this.$store.commit('setStates', Object.keys(boundaries))
      let options = {
          strokeColor: '#AAB2B5',
          strokeWeight: 2,
          fillColor: '#AAB2B5',
      }
      _.forEach(this.$store.getters.states, stateData => {

        mapHelper.makeStatePolygon(stateData, boundaries, options)
        if (this.$store.getters.excludedAreas.findIndex(estate => { return estate.state === stateData }) > -1) {
           this.$store.getters.polygons[stateData].setOptions({ strokeOpacity: 0.4, fillOpacity: 0.4 })
        }
        this.polygonHoverListners(stateData)
        this.polygonClickListner(stateData)
        this.$store.getters.polygons[stateData].setMap(this.$store.getters.map)

      })
      this.initSelectedStates()
      return 
    },
    selectPolygon (polygon, state) {
      let excluded_area = {
          state: state,
          abbreviation: stateHelper.getAbbreviationByState(state)
      }
      this.$store.dispatch('addExclusionPolygon', excluded_area)
      polygon.setOptions({ strokeOpacity: 0.4, fillOpacity: 0.4 })
    },
    unselectPolygon (polygon, state) {
      let excluded_areas = this.$store.getters.excludedAreas;
      excluded_areas = _.filter(excluded_areas, (next_item) => {
          return next_item.state != state;
      })

      this.$store.commit('setExcludedAreas', excluded_areas);
      // this.$store.dispatch('removeExclusionPolygon', {index: this.$store.getters.excludedAreas.findIndex(estate => { return estate === state })})
      polygon.setOptions({ strokeOpacity: 0, fillOpacity: 0 })
    },
    finishProcess() {
      this.$router.push("../review" )
    }
  }
}


// WEBPACK FOOTER //
// ./src/pages/Pickup/GetExclusion/get-state-exclusion.script.js